import { createFileRoute } from '@tanstack/react-router';
import { OldPageSeo } from './-components/page-seo';
import { lazy, Suspense } from 'react';
import { useLingui } from '@lingui/react/macro';
import { Layout, Title } from './-components/layout';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { Skeleton } from '@worldcoo/ui/components/skeleton';

const ContactForm = lazy(() => import('../-components/contact-form').then((m) => ({ default: m.ContactForm })));

export const Route = createFileRoute('/old/contact')({
	component: Component,
});

function ContactFormSkeleton() {
	return (
		<div className="flex flex-col gap-6">
			{Array.from({ length: 3 }, (_, i) => (
				<div key={i} className="flex flex-col gap-3">
					<Skeleton className="h-4 w-16" />
					<Skeleton className="h-8 w-full" />
				</div>
			))}
			<div className="flex flex-col gap-3">
				<Skeleton className="h-4 w-16" />
				<Skeleton className="h-8 w-full" />
			</div>
			<div className="flex flex-col gap-3">
				<Skeleton className="h-4 w-20" />
				<Skeleton className="h-24 w-full" />
			</div>
			<div className="flex items-center gap-3">
				<Skeleton className="h-4 w-4" />
				<Skeleton className="h-4 w-64" />
			</div>
			<Skeleton className="h-8 w-24" />
		</div>
	);
}

function Component() {
	const { t } = useLingui();

	return (
		<Layout>
			<Header />
			<OldPageSeo
				title={t`Contact - Worldcoo`}
				description={t`If you'd like to incorporate Charity Rounding Up, if you're a social entity, or if you'd like some more information, please contact us.`}
			/>

			<section className="bg-hero py-16 md:py-24">
				<div className="mx-auto flex max-w-6xl flex-col gap-12 px-8">
					<Title>
						{t`If you'd like to incorporate Charity Rounding Up, if you're a social entity, or if you'd like some more information, please contact us.`}
					</Title>

					<div className="grid gap-12 lg:grid-cols-2">
						<div className="bg-background shadow-3xl rounded-lg p-8">
							<Suspense fallback={<ContactFormSkeleton />}>
								<ContactForm />
							</Suspense>
						</div>

						<div className="flex flex-col gap-3">
							<div className="p-8">
								<h2 className="mb-4 text-xl font-bold">{t`Contact details`}</h2>
								<ul className="flex flex-col gap-2">
									<li>
										<a href="tel:+34936110104" className="hover:text-primary transition-colors">
											T. (+34) 936 11 01 04
										</a>
									</li>
									<li>
										<a
											href="https://goo.gl/maps/5DDj97UEuZTjRb9P9"
											target="_blank"
											rel="noopener noreferrer"
											className="hover:text-primary transition-colors"
										>
											Carrer de Llull, 112, Sant Martí, 08005 Barcelona
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Footer />
		</Layout>
	);
}
